const DEFAULT_SCORES = {
    MAXIMUM: 10,
    GOOD: 9,
    NOTICE: 7,
    WARNING: 5,
    DANGER: 2,
    ERROR: 1,
    UNKNOWN: -1,
}

export const SCORE_COLOR_MINIMUMS = {
    GREEN: 8,
    YELLOW: 3,
    RED: 0,
    GREY: -1,
}

function radioHasIntegratedPower(radio) {
    return radio.serial_number.startsWith('MNE')
}

function getAntennaScore(radio) {
    let score = DEFAULT_SCORES.UNKNOWN
    const lastHealthCheck = radio?.latest_health_check

    if (!lastHealthCheck) {
        return score
    }

    const antennaQuality = lastHealthCheck.antenna_quality

    const normalizedValue = antennaQuality === null ? null : antennaQuality.toUpperCase()

    switch (normalizedValue) {
        case 'EXCELLENT':
            score = DEFAULT_SCORES.MAXIMUM
            break
        case 'GOOD':
            score = DEFAULT_SCORES.GOOD
            break
        case 'AVERAGE':
            score = DEFAULT_SCORES.WARNING
            break
        case 'POOR':
            score = DEFAULT_SCORES.DANGER
            break
        case 'BAD':
            score = DEFAULT_SCORES.ERROR
            break
        default:
            score = DEFAULT_SCORES.UNKNOWN
            break
    }

    return score
}

function getBatteryScore(radio) {
    let score = DEFAULT_SCORES.UNKNOWN
    const lastHealthCheck = radio?.latest_health_check

    if (!lastHealthCheck) {
        return score
    }

    const batteryLevel = lastHealthCheck.battery_level

    if (batteryLevel === null) {
        score = DEFAULT_SCORES.UNKNOWN
    } else if (batteryLevel === 100) {
        score = DEFAULT_SCORES.MAXIMUM
    } else if (batteryLevel >= 75 && batteryLevel <= 99) {
        score = DEFAULT_SCORES.GOOD
    } else if (batteryLevel >= 51 && batteryLevel <= 74) {
        score = DEFAULT_SCORES.NOTICE
    } else if (batteryLevel >= 26 && batteryLevel <= 50) {
        score = DEFAULT_SCORES.WARNING
    } else if (batteryLevel >= 11 && batteryLevel <= 25) {
        score = DEFAULT_SCORES.DANGER
    } else if (batteryLevel >= 0 && batteryLevel <= 10) {
        score = DEFAULT_SCORES.ERROR
    }

    return score
}

function getChargingScore(radio) {
    let score = DEFAULT_SCORES.UNKNOWN
    const lastHealthCheck = radio?.latest_health_check

    if (!lastHealthCheck) {
        return score
    }

    const isCharging = lastHealthCheck.is_charging
    const usbConnected = lastHealthCheck.usb_connected

    if (isCharging === undefined || isCharging === null || usbConnected === undefined || usbConnected === null) {
        score = DEFAULT_SCORES.UNKNOWN
    } else if (usbConnected) {
        score = DEFAULT_SCORES.MAXIMUM
    } else if (!isCharging) {
        score = DEFAULT_SCORES.ERROR
    }
    return score
}

export function getRadioScore(radio) {
    const antenna = getAntennaScore(radio)
    const battery = radioHasIntegratedPower(radio) ? DEFAULT_SCORES.MAXIMUM : getBatteryScore(radio)
    const charging = getChargingScore(radio)

    return {
        value: Math.min(antenna, battery, charging),
        individual: {
            antenna,
            battery,
            charging,
        },
    }
}

export function getRelayScore(relay) {
    const radios = relay.assembly.members_with_asset
        .filter((member) => member.asset_type === 'asset_radio' && member.asset !== null) // TODO: enum
        .map((member) => ({
            name: member.label,
            ...member.asset,
        }))
    let score = radios.length > 0 ? DEFAULT_SCORES.MAXIMUM : DEFAULT_SCORES.UNKNOWN
    const scoreObjects = []
    for (let x = 0; x < radios.length; x++) {
        const radio = radios[x]
        const scoreObject = {
            ...getRadioScore(radio),
            radioId: radio.id,
        }
        scoreObjects.push(scoreObject)
        score = Math.min(scoreObject.value, score)
    }

    return {
        value: score,
        individual: scoreObjects,
    }
}

export function getColorForScore(score) {
    let color = 'grey'
    if (score >= SCORE_COLOR_MINIMUMS.GREEN) {
        color = 'green'
    } else if (score >= SCORE_COLOR_MINIMUMS.YELLOW) {
        color = 'yellow'
    } else if (score >= SCORE_COLOR_MINIMUMS.RED) {
        color = 'red'
    }

    return color
}
